import styled from "styled-components";

export const Tabs = styled.div`
  width: 100%;
  padding-top: 40px;
`

export const TabsInner = styled.div`
  overflow-x: scroll;
  display: flex;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const TabTitle = styled.div`
  font-size: 14px;
  line-height: 140%;
  color: #2A2637;
`

export const Tab = styled.div`
  flex: 0 0 52%;
  padding: 0 25px 25px;
  
  &:last-child {
    margin-right: 0;
  }
`

export const TabNonActive = styled(Tab)`
  ${TabTitle} {
    font-weight: 400;
    color: #797199;
    
    span {
      color: #797199;
    }
  }
`

export const TabActive = styled(Tab)`
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    display: block;
    bottom: 0;
    left: 25px;
    right: 25px;
    height: 6px;
    border-radius: 22px;
    background: #01C716;
  }
  
  ${TabTitle} {
    font-weight: 700;
  }
`

export const Dot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #D1D0DA;
  cursor: pointer;
`

export const Dots = styled.div`
  margin-bottom: 40px;
  
  ul {
    padding: 0;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  li {
    padding: 10px;
  }
  
  .slick-active {
    ${Dot} {
      background: #0D71D7;
    }
  }
    @media(min-width: 980px) {
        margin-top: 60px;
    }
`
